import React from 'react';
import ReactDOM from 'react-dom';
import { connect, Provider } from 'react-redux';
import FiltersContainerMain from './components/Filtering/FiltersContainerMain';

function mapStateToProps(state) {
  return {
    filters: state.listingPage.filters.list,
    deviceType: state.general.device.deviceType
  };
}

export default function initFilters() {
  const ConnectedFiltersContainer = connect(mapStateToProps)(FiltersContainerMain);
  const mountEl = document.querySelector('[data-component="listing-page-filters"]');

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <ConnectedFiltersContainer />
      </Provider>, mountEl
    );
  }
}
